import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Common_navber.css";
import { useSelector } from "react-redux";

const AnimatedNavbar = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
   const { isAuthenticated ,token} = useSelector((state) => state.auth);

  // 🔥 Detect Scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Booking", path: "/booking" },
    { label: "Gallery", path: "/" },
    { label: "Contact", path: "/" },
  ];

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      className={`custom-navbar scrolled`}
    >
      <Container>
        <Navbar.Brand
          className="nav-logo"
          onClick={() => navigate("/")}
        >
          Ganga Kinare <span>Banquet</span>
        </Navbar.Brand>

        <Navbar.Toggle
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />

        <Navbar.Collapse>
          <Nav className="ms-auto nav-links">
            {navItems.map((item, index) => (
              <Nav.Link
                key={index}
                className="nav-link-item"
                onClick={() => {
                  navigate(item.path);
                  setExpanded(false);
                }}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>

        
         <img src="/user.png" style={{margin:"0px 20px",width:"30px",backgroundColor:"white",borderRadius:"50%"}}
         onClick={()=>{isAuthenticated?navigate("/profile"):navigate("/login")}}/>
      </Container>
    </Navbar>
  );
};

export default AnimatedNavbar;